import React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { useTheme } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from "@mui/icons-material/Error";

interface DtAlertProps extends AlertProps {}

const DtAlert: React.FC<DtAlertProps> = (props) => {
    const theme = useTheme();

      const getIcon = (severity: AlertProps["severity"]) => {
        switch (severity) {
            case "info":
                return <InfoIcon fontSize="inherit" sx={{ mr: 1 }} />;
            case "success":
                return <CheckCircleIcon fontSize="inherit" sx={{ mr: 1 }} />;
            case "warning":
                return <WarningIcon fontSize="inherit" sx={{ mr: 1 }} />;
            case "error":
                return <ErrorIcon fontSize="inherit" sx={{ mr: 1 }} />;
            default:
                return null;
        }
    };

    return (
        <MuiAlert
            {...props}
            icon={props.icon || getIcon(props.severity)}
            sx={{
                fontWeight: 500,
                fontSize: "0.92rem",
                ...props.sx,
            }}
        />
    );
};

export default DtAlert;